import React from 'react';
import { SBadge, SIcon } from '@chargebee/sting-react';
import { cs, type Argument } from '@bbkAdminUtils/css-utils';

import './styles/stat.scss';

type Props = {
  value: number | string;
  change?: number; // chevron direction >= 1 up, < 1 down
  bg?: number; // bg color of badge: >= 1 green, < 1 red
  outline?: boolean;
  outlineLight?: boolean;
  badgeClasses?: Argument;
  badgeIconClasses?: Argument;
};
export const StatBadge: React.FC<Props> = (props) => {
  const {
    change,
    value,
    badgeClasses,
    badgeIconClasses,
    bg,
    outline,
    outlineLight,
  } = props;
  const variant = bg ? (bg >= 1 ? 'success' : 'danger') : 'neutral';
  const mode = outline || outlineLight ? 'outline' : 'light';
  const chevron = change ? (
    <SIcon
      name={change >= 1 ? 'chevron-up' : 'chevron-down'}
      size={14}
      className={cs(badgeIconClasses)}
    />
  ) : undefined;
  return (
    <SBadge
      variant={variant}
      mode={mode}
      size="regular"
      icon={chevron}
      className={cs(badgeClasses)}
    >
      {value}
    </SBadge>
  );
};
